import { ToggleButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';
import { MemberStatusTabKeysEnum } from 'src/shared/models/enums/memberStatusTabKeys.enum';
import { MemberTabItem, memberTabs } from '../models/memberTabs';

const limitedMemberTabs = memberTabs.filter((x) => x.key !== 'active');

type MemberAdvancedSearchStatusesProps = {
  otherContactMode: boolean;
};

export const MemberAdvancedSearchStatuses = (props: MemberAdvancedSearchStatusesProps) => {
  const { otherContactMode } = props;
  const isMounted = useIsMounted();
  const { setValue, getValues, watch } = useFormContext();
  const { t } = useTranslation(['member']);

  const [selectedKeys, setSelectedKeys] = useState<string[]>([MemberStatusTabKeysEnum.Paid, MemberStatusTabKeysEnum.NotPaid]);

  const handleKeys = (_event: React.MouseEvent<HTMLElement>, newKeys: string[]) => {
    setSelectedKeys(newKeys);
    const selected = limitedMemberTabs.filter((item) => newKeys.includes(item.key));
    setValue('status', selected || []);
  };

  const statusFromContext = watch('status');

  useEffect(() => {
    if (isMounted()) {
      if (statusFromContext && statusFromContext.length) {
        setSelectedKeys(statusFromContext.map((x: MemberTabItem) => x.key));
      }
    }
  }, [getValues, isMounted, setValue, statusFromContext]);

  return (
    <FormFieldset legend={t('member:memberAdvancedSearch.status')} inflowLegend noPadding>
      <StyledToggleButtonGroup value={selectedKeys} onChange={handleKeys} color='primary' size='small'>
        {limitedMemberTabs
          .filter((x) => !(x.hiddenForOtherContactMode && otherContactMode))
          .map((x) => (
            <ToggleButton value={x.key} key={x.key}>
              {t(x.label)}
            </ToggleButton>
          ))}
      </StyledToggleButtonGroup>
    </FormFieldset>
  );
};
